import HeaderTabs, {tabsDictionary} from './HeaderTabs';

export {tabsDictionary};
export default HeaderTabs;
